import { Pipe, PipeTransform } from '@angular/core';

import { DictionaryService } from '../services/dictionary/dictionary.service';

@Pipe({
  name: 'titlemapper'
})
export class TitleMapperPipe implements PipeTransform {
  constructor(private dictionaryService: DictionaryService) {}
  transform(value: any, key?: any): any {
    return this.dictionaryService.dictionary[key];
  }
}
